import React from 'react';
import {Constants} from "../../constants";
import Redirect from "react-router-dom/es/Redirect";

export default class RedirectIfNotLogged extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            forceLogin: false
        }
    }

    componentDidMount() {
        if (!localStorage.getItem(Constants.STORAGE_JWT_TOKEN_KEY)) {
            this.setState({
                forceLogin: true
            });
        }
    }

    render() {
        return (
            <div>
                {
                    this.state.forceLogin ? <Redirect to={"/forbidden"}/> : null
                }
            </div>
        )
    }
}